import {Content, ContentHeader, Header, Page, SupportButton} from '@backstage/core-components';
import {
  configApiRef,
  createRoutableExtension,
  createRouteRef,
  useApi,
} from '@backstage/core-plugin-api';
import React from 'react';
import {catalogImportPlugin} from '@backstage/plugin-catalog-import';
import {RegisterWizard} from './register-wizard/RegisterWizard';

const rootRouteRef = createRouteRef({
  id: 'catalog-import',
});

const CustomCatalogImportPage = () => {
  const configApi = useApi(configApiRef);
  const appTitle = configApi.getOptional('app.title') || 'Backstage';

  return (
    <Page themeId='home'>
      <Header title='Register an existing component' />
      <Content>
        <ContentHeader title={`Start tracking your component in ${appTitle}`}>
          <SupportButton />
        </ContentHeader>
        <RegisterWizard />
      </Content>
    </Page>
  );
};

export const CatalogImportPage = catalogImportPlugin.provide(
  createRoutableExtension({
    name: 'CatalogImportPage',
    component: async () => CustomCatalogImportPage,
    mountPoint: rootRouteRef,
  }),
);
